var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-page-content-wrapper features" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("settings.auto_assign"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v(_vm._s(_vm.$t("message.changeSettings"))),
      ]),
    ]),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        { staticClass: "features" },
        [
          _vm._l(_vm.features, function (feature) {
            return _c("FeatureItem", {
              key: feature.id,
              attrs: {
                title: feature.title,
                description: feature.description,
                value: _vm.readValue(feature.id),
                icon: feature.icon,
                type: feature.type,
                min: feature.min,
                max: feature.max,
                step: feature.step,
              },
              on: {
                input: function ($event) {
                  return _vm.setValue(feature.id, $event)
                },
              },
            })
          }),
          _vm._v(" "),
          _c(
            "FeatureItem",
            {
              attrs: {
                title: _vm.$t("message.algorithm"),
                icon: "RoundRobin",
                description: _vm.$t("message.algo_desc"),
                type: "select",
                options: _vm.algorithms,
                "default-select-option-placeholder": "Select an Algorithm",
              },
              model: {
                value: _vm.algorithm,
                callback: function ($$v) {
                  _vm.algorithm = $$v
                },
                expression: "algorithm",
              },
            },
            [
              _c(
                "div",
                { staticClass: "algorithms d-flex flex-column gap-5" },
                [
                  _c("div", [
                    _c("b", [_vm._v("Ordered")]),
                    _vm._v(": " + _vm._s(_vm.$t("message.ordered_desc"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("b", [_vm._v("Random")]),
                    _vm._v(": " + _vm._s(_vm.$t("message.random_desc"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("b", [_vm._v("Round Robin")]),
                    _vm._v(": " + _vm._s(_vm.$t("message.Rrobin_desc"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("b", [_vm._v("Round Robin Reverse")]),
                    _vm._v(": " + _vm._s(_vm.$t("message.RrobinRev_desc"))),
                  ]),
                ]
              ),
            ]
          ),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }